module.exports = __webpack_public_path__ + "202419:4ba491f0bd9615732354/img/Till-This-Day-Tile_no-spot.44aac0a.png";